// a 500/504 means the server already ran (or is still running) the request; retrying only multiplies load
export const RETRYABLE_HTTP_STATUSES: readonly number[] = [429, 502, 503];
